import datapoints from '../datapoints';
import getDatapointOptions from '../getDatapointOptions';
import { getAdapter } from 'owa-addins-apis';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getClientApp, getUserCulture } from 'owa-session-store';
import {
    IAddinCommand,
    ExtensionEntryPointEnum,
    getScenarioFromHostItemIndex,
} from 'owa-addins-store';

export const logAddinUsage = (
    success: boolean,
    addinCommand: IAddinCommand,
    hostItemIndex: string,
    entrypoint: ExtensionEntryPointEnum,
    errorCode?: number
) => {
    if (!isFeatureEnabled('addin-launchDatapoint')) {
        return;
    }

    let isSharedItem = getIsSharedItem(hostItemIndex);

    logAddinLaunched(success, addinCommand, hostItemIndex, entrypoint, errorCode, isSharedItem);

    // Only log the delegate add-in launched datapoint for delegate scenarios
    if (success && isSharedItem) {
        logDelegateAddinLaunched(addinCommand, hostItemIndex);
    }
};

function getIsSharedItem(hostItemIndex: string): boolean {
    if (isFeatureEnabled('addin-delegateAccess')) {
        const adapter = getAdapter(hostItemIndex);

        if (adapter.isSharedItem) {
            return adapter.isSharedItem();
        }
    }

    return false;
}

function logAddinLaunched(
    success: boolean,
    addinCommand: IAddinCommand,
    hostItemIndex: string,
    entrypoint: ExtensionEntryPointEnum,
    errorCode: number,
    isSharedItem: boolean
) {
    let { customData, name } = datapoints.ExtAddinLaunched.datapoint;
    const datapoint = new PerformanceDatapoint(name, getDatapointOptions());
    datapoint.addCustomData(
        customData(
            addinCommand.extension.Id,
            addinCommand.extension.DisplayName,
            getClientApp(),
            getScenarioFromHostItemIndex(hostItemIndex),
            entrypoint,
            getUserCulture(),
            addinCommand.extension.Type,
            errorCode,
            isSharedItem
        )
    );

    if (success) {
        datapoint.end();
    } else {
        datapoint.endWithError(
            DatapointStatus.Timeout,
            new Error('Add-in failed to load with code: ' + errorCode)
        );
    }
}

function logDelegateAddinLaunched(addinCommand: IAddinCommand, hostItemIndex: string) {
    let { customData, name } = datapoints.ExtDelegateAddinLaunched.datapoint;

    const datapoint = new PerformanceDatapoint(name, getDatapointOptions());
    datapoint.addCustomData(
        customData(
            addinCommand.extension.Id,
            addinCommand.extension.DisplayName,
            getClientApp(),
            getScenarioFromHostItemIndex(hostItemIndex)
        )
    );

    datapoint.end();
}
